import { defineMessages } from 'react-intl';

export const managementReportSummaryTableMessageDefinitions = defineMessages({
  subtotal: {
    id: 'estimation.detail.managementReport.summaryTable.subtotal',
    defaultMessage: 'Subtotal',
  },
  emptyTableText: {
    id: 'estimation.detail.managementReport.summaryTable.emptyTableText',
    defaultMessage: 'No data available',
  },
  projectPhase: {
    id: 'estimation.detail.managementReport.summaryTable.projectPhase',
    defaultMessage: 'Project Phase',
  },
  reference: {
    id: 'estimation.detail.managementReport.summaryTable.reference',
    defaultMessage: 'Reference',
  },
  estimate: {
    id: 'estimation.detail.managementReport.summaryTable.estimate',
    defaultMessage: 'Estimate',
  },
  assumptions: {
    id: 'estimation.detail.managementReport.summaryTable.assumptions',
    defaultMessage: 'Assumptions',
  },
  totalEfforts: {
    id: 'estimation.detail.managementReport.summaryTable.totalEfforts',
    defaultMessage: 'Total Efforts',
  },
  directCostItem: {
    id: 'estimation.detail.managementReport.summaryTable.directCostItem',
    defaultMessage: 'Direct Cost Item',
  },
  total: {
    id: 'estimation.detail.managementReport.summaryTable.total',
    defaultMessage: 'Total',
  },
  noAssumptions: {
    id: 'estimation.detail.managementReport.summaryTable.noAssumptions',
    defaultMessage: 'No assumptions',
  },
  noDirectCostItems: {
    id: 'estimation.detail.managementReport.summaryTable.noDirectCostItems',
    defaultMessage: 'No direct cost items to display',
  },
  comments: {
    id: 'estimation.detail.managementReport.summaryTable.comments',
    defaultMessage: 'Comments',
  },
});
